/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Partnercompanies1Inputs */

const en__field_partnercompanies1 = /** @type {(inputs: _Field_Partnercompanies1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner companies`)
};

/**
* | output |
* | --- |
* | "Partner companies" |
*
* @param {_Field_Partnercompanies1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_partnercompanies1 = /** @type {((inputs?: _Field_Partnercompanies1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Partnercompanies1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_partnercompanies1(inputs)
});
export { _field_partnercompanies1 as "_field_partnerCompanies" }